import { render } from "./SpotsCreate.vue?vue&type=template&id=7a13d204"
import script from "./SpotsCreate.vue?vue&type=script&lang=js"
export * from "./SpotsCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__